import React, { useState } from "react";
import "./DimensionsTab.css";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import SelectUnselectExtended from "src/components/Input/SelectUnselectExtended/SelectUnselectExtended";
import { initialConfiguration } from "src/hooks/useConfigurationState";
import { RoofGlassMat } from "src/types/configuration";

export const structureColor = [
  // {
  //   id: 0,
  //   name: "JetBlack, RAL 9015",
  //   // name: "Mat zwart - RAL9005MS",
  //   color: "#2a292a",
  //   value: "mat_black",
  //   price: 0,
  //   carouselImages: [`${process.env.PUBLIC_URL}/images/ral9015.jpg`],
  //   description:
  //     "",
  // },
  {
    id: 1,
    name: "Wit, RAL 9010",
    // name: "Mat crème wit - RAL9001MS",
    color: "#f7f9ef",
    value: "mat_white",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral9010.jpg`],
    description:
      "",
  },
  {
    id: 2,
    name: "Antraciet, RAL 7016",
    // name: "Mat antraciet - RAL7016MS",
    color: "#353C40",
    value: "mat_blue",
    price: 0,
    carouselImages: [`${process.env.PUBLIC_URL}/images/ral7016.jpg`],
    description:
      "",
  },
  // {
  //   id: 3,
  //   name: "QuartzGrey, RAL 7039",
  //   color: "#6b665e",
  //   value: "mat_brown",
  //   carouselImages: [`${process.env.PUBLIC_URL}/images/ral7016.jpg`],
  //   description:
  //     "",
  // },
];

const Component: React.FC = () => {
  const { state, setSpy, setRoofGlassMat, setGutter, configuration } =
    useConfiguration();

  // One baseline for the whole group: the default roof material. Glass options
  // therefore carry the full cost of switching family, and Helder
  // Polycarbonaat — the default — comes out at zero and renders blank.
  const roofMaterialSurcharge = (option: Partial<RoofGlassMat>) =>
    configuration.calculationService.getSurcharge(
      { roofGlassMat: { ...initialConfiguration.roofGlassMat, ...option } },
      { roofGlassMat: initialConfiguration.roofGlassMat }
    );

  const handleGlassChange = (value: string) => {
    if (
      value === "poly" &&
      (state.roofGlassMat.glass === "poly" ||
        state.roofGlassMat.glass === "polywide")
    )
      return;
    if (state.roofGlassMat.glass === value) return;

    setRoofGlassMat({
      ...state.roofGlassMat,
      glass: value,
      glassshade: "light",
    });
  };

  const handleGlassShadeChange = (value: string) => {
    if (state.roofGlassMat.glassshade === value) return;
    setRoofGlassMat({
      ...state.roofGlassMat,
      glassshade: value,
    });
  };

  const handlePolyShadeChange = (value: string) => {
    if (state.roofGlassMat.polyshade === value && state.roofGlassMat.glass === "poly")
      return;

    setRoofGlassMat({
      ...state.roofGlassMat,
      glass: "poly",
      polyshade: value,
    });
  };

  const handleGooter = (value: string) => {
    if (state.gutter.type === value) return;
    setGutter({ ...state.gutter, type: value });
  };

  const handleSpyLeftChange = (enabled: boolean) => {
    if (state.spy.left === enabled) return;
    setSpy({ ...state.spy, left: enabled });
  };

  const handleSpyRightChange = (enabled: boolean) => {
    if (state.spy.right === enabled) return;
    setSpy({ ...state.spy, right: enabled });
  };

  const polyShadeComponent = () => {
    return (
      <>
        <RadioBlocksExtended
          blocks={[
            {
              id: 0,
              name: "Helder Polycarbonaat",
              value: "mid",
              price: roofMaterialSurcharge({ polyshade: "mid" }),
              imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_mid.png`,
              description:
                "Heldere robuuste platen, die het licht goed doorlaten.",
            },
            {
              id: 1,
              name: "Opaal Polycarbonaat",
              value: "light",
              price: roofMaterialSurcharge({ polyshade: "light" }),
              imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_light.png`,
              description:
                "Melkwitte robuuste platen, die zorgen voor privacy en een perfecte bescherming tegen het zonlicht.",
            },
            {
              id: 2,
              // name: "Blackline - Helder met zwarte strepen",
              name: "Zonwerend Polycarbonaat",
              value: "dark",
              price: roofMaterialSurcharge({ polyshade: "dark" }),
              imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_dark.png`,
              description:
                "Heldere robuuste platen, met een speciale infrarood-coating die de warmtestraling reflecteert, waardoor het terras merkbaar koeler blijft.",
            },
            {
              id: 3,
              name: "Breed helder polycarbonaat",
              value: "wide",
              price: roofMaterialSurcharge({ polyshade: "wide" }),
              imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_wide.png`,
              description:
                "Heldere robuuste platen met extra brede kanalen (32 mm) voor een beter doorzicht naar boven, maximale lichtinval en een rustiger effect op het dak.",
            },
          ]}
          value={
            state.roofGlassMat.glass === "polywide"
              ? "wide"
              : state.roofGlassMat.polyshade
          }
          onChange={handlePolyShadeChange}
          className={"inner_child"}
          parentIsSelected={
            state.roofGlassMat.glass === "poly" ||
            state.roofGlassMat.glass === "polywide"
          }
        />
      </>
    );
  };

  const glassShadeComponent = () => {
    return (
      <>
        {/* <Text content="Glass Shade" /> */}
        <RadioBlocksExtended
          blocks={[
            {
              id: 0,
              name: "Helder",
              value: "light",
              color: "#9BFFBE",
              price: roofMaterialSurcharge({
                glass: "glass",
                glassshade: "light",
              }),
              imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_light.png`,
              description:
                "Geniet van een volledig vrij, onbelemmerd uitzicht naar de lucht. Dit glas laat al het (dag)licht ongewijzigd door, waardoor ook de aangrenzende woonkamer heerlijk licht blijft.",
            },
            {
              id: 1,
              name: "Melk/Opaal",
              value: "melk",
              color: "#9BFFBE",
              price: roofMaterialSurcharge({
                glass: "glass",
                glassshade: "melk",
              }),
              imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_light.png`,
              description:
                "De matte, melkwitte uitstraling voorkomt inkijk van bovenaf en houdt de ergste warmte van de zon effectief buiten de veranda.",
            },
            // {
            //   id: 2,
            //   name: "Zonwerend",
            //   value: "dark",
            //   color: "#9BFFBE",
            //   price: configuration.calculationService.getGlass("glassdark"),
            //   imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_dark.png`,
            //   description:
            //     "",
            // },
          ]}
          value={state.roofGlassMat.glassshade}
          onChange={handleGlassShadeChange}
          className={"inner_child"}
          parentIsSelected={state.roofGlassMat.glass === "glass"}
        />
      </>
    );
  };

  return (
    <>
      {/* <Text content="Glass Material" /> */}
      <RadioBlocksExtended
        blocks={[
          {
            id: 0,
            name: "Glas",
            value: "glass",
            imageUrl: `${process.env.PUBLIC_URL}/images/ver_glass_light.png`,
            component: glassShadeComponent,
            description:
              "Oersterk gecertificeerd 44.2 gelaagd veiligheidsglas, bestaande uit twee glasplaten met een taaie, onzichtbare tussenfolie, wat zorgt voor maximale veiligheid.",
          },
          {
            id: 1,
            name: "Polycarbonaat",
            value: "poly",
            imageUrl: `${process.env.PUBLIC_URL}/images/ver_poly_dark.png`,
            component: polyShadeComponent,
            description:
              "Van Kooten maakt standaard gebruik van 16 mm dikke platen. De platen hebben een specifieke kamerstructuur (tunnels), voorzien van een X-structuur die extra robuustheid geven aan de dakplaten.",
          },
        ]}
        value={state.roofGlassMat.glass === "polywide" ? "poly" : state.roofGlassMat.glass}
        onChange={handleGlassChange}
        className={"root-type-radio-blocks"}
      />
    </>
  );
};

const DimensionsTab: React.FC = () => {
  const { state, setDimensions, setRoofMaterial } = useConfiguration();

  const handleRoofMaterial = (value: string) => {
    if (state.roofType === value) return;
    setRoofMaterial(value);
  };

  const getGlass = () => {
    const value = state.roofGlassMat;
    const type = value.glass;

    if (type === "glass") {
      if (value.glassshade === "light") return "Glas Helder";
      else if (value.glassshade === "melk") return "Glas Melk";
      else return "Glas Zonwerend";
    } else if (type === "poly") {
      const shade = value.polyshade;
      if (shade === "light") return "Opaal Polycarbonaat";
      else if (shade === "dark") return "Zonwerend Polycarbonaat";
      else if (shade === "mid") return "Helder Polycarbonaat";
      else if (shade === "wide") return "Breed helder polycarbonaat";
      else return "Helder Polycarbonaat";
    } else return "Breed helder polycarbonaat";

    return "helder";
  };

  const carousel = [
    `${process.env.PUBLIC_URL}/images/ver_mat_black.jpg`,
    `${process.env.PUBLIC_URL}/images/ver_mat_white.jpg`,
    `${process.env.PUBLIC_URL}/images/ver_mat_blue.jpg`,
    `${process.env.PUBLIC_URL}/images/ver_mat_brown.jpg`,
  ];

  return (
    <div className="dimensions-tab">
      <SelectUnselectExtended
        name="Kleur"
        deselectByCheckboxOnly={true}
        imageUrl={`${process.env.PUBLIC_URL}/images/ver_materials.png`}
        description=""
        isSelected={true}
        onSelect={() => true}
        onUnselect={() => false}
        alwaysShowSelected={true}
        carouselImages={carousel}
        Component={() => (
          <RadioBlocksExtended
            blocks={structureColor}
            value={state.roofMaterial}
            onChange={handleRoofMaterial}
            className={"inner_child"}
          />
        )}
        selectedNames={`${
          structureColor.find((i) => i.value === state.roofMaterial)?.name
        }`}
      />

      <SelectUnselectExtended
        name="Dakmateriaal"
        deselectByCheckboxOnly={true}
        imageUrl={`${process.env.PUBLIC_URL}/images/ver_glass_light.png`}
        description=""
        isSelected={true}
        onSelect={() => true}
        onUnselect={() => false}
        alwaysShowSelected={true}
        Component={Component}
        selectedNames={getGlass()}
      />
    </div>
  );
};

export default DimensionsTab;
